export const getStatesOptions = (states = []) =>
  states.map(
    ({ stateCode }) => ({ label: stateCode, value: stateCode })
  )
